import { Pipe, PipeTransform } from '@angular/core';

import { temperaturas } from '../temperatura';

@Pipe({
    name: 'temperatura'
})
export class TemperaturaPipe implements PipeTransform {
    transform(value: number): string {
        if (!value) {
            return '';
        }

        const index = temperaturas.findIndex(temperatura => temperatura.id === value);
        if (index > -1) {
            return temperaturas[index].nome;
        }
        return '';
    }
}
